import { type ComponentProps } from 'react'
import { Combobox } from '@base-ui/react/combobox'
import { twMerge } from 'tailwind-merge'
import { listGroupLabel } from '../../../lib/list-styles'
import type { PartProps } from '../../../lib/part-props'

interface ComboboxGroupLabelProps extends PartProps<ComponentProps<typeof Combobox.GroupLabel>> {
  className?: string
}

/** The same group label Menu and Select use. */
function ComboboxGroupLabel({ className, ...props }: ComboboxGroupLabelProps) {
  return <Combobox.GroupLabel className={twMerge(listGroupLabel, className)} {...props} />
}

export { ComboboxGroupLabel }
